import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { ROUTES } from '../../config/routes';
import { LoadingScreen } from '../../shared/components/Lounge';

export function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return <LoadingScreen text="Abriendo tu panel…" />;

  if (!user) return <Navigate to={ROUTES.LOGIN} replace />;
  return children;
}
